import { useEffect, useState } from "react";
import { useApiContext } from 'context/ApiContext';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDPopup from "components/MDPopup";
import MDTypography from "components/MDTypography";

// Overview page components
import Create from "layouts/mainAdministration/pages/components/Users/Create";
import Header from "layouts/mainAdministration/pages/components/Users/Header";
import Modify from "layouts/mainAdministration/pages/components/Users/Modify";
import Visualize from "layouts/mainAdministration/pages/components/Users/Visualize";

function UserForm() {
    const { parksAdm, userFormInfosAdm, popupUserFormError, setPopupUserFormError } = useApiContext();

    const [selectedUser, setSelectedUser] = useState(null);
    const [availableParks, setAvailableParks] = useState(null);
    const [formType, setFormType] = useState(null);

    const [openErrorDialog, setOpenErrorDialog] = useState(false);

    const userRole = localStorage.getItem('userRole');

    useEffect(() => {
        if (parksAdm) {
            setAvailableParks(parksAdm);
        }
    }, [parksAdm]);

    useEffect(() => {
        if ((userFormInfosAdm && userFormInfosAdm.selectedUser) || (userFormInfosAdm && userFormInfosAdm.formType === "CreateUser")) {
            setSelectedUser(userFormInfosAdm.selectedUser);
            setFormType(userFormInfosAdm.formType);
        }
    }, [userFormInfosAdm]);

    useEffect(() => {
        if (popupUserFormError) {
            setOpenErrorDialog(true);
        }
    }, [popupUserFormError]);

    const handleCloseErrorDialog = () => {
        setOpenErrorDialog(false);
        setPopupUserFormError(null);
    };

    return (
        <MDBox>
            {formType === "CreateUser" ? (
                <>
                    <Header currentRole={userRole} formType={formType}>
                        <Create parks={availableParks} currentRole={userRole} />
                    </Header>
                </>
            ) : formType === "ModifyUser" ? (
                <>
                    <Header user={selectedUser} currentRole={userRole} formType={formType}>
                        <Modify user={selectedUser} parks={availableParks} currentRole={userRole} />
                    </Header>
                </>
            ) : formType === "VisualizeUser" && (
                <>
                    <Header user={selectedUser} currentRole={userRole} formType={formType}>
                        <Visualize user={selectedUser} />
                    </Header>
                </>
            )}
            <MDPopup
                open={openErrorDialog}
                onClose={handleCloseErrorDialog}
                title="Error"
                body={popupUserFormError || "An unknown error occurred."} /*body="This user already exists, remember to use a new email address."*/
                confirmLabel="OK"
                showConfirmButton={false}
                showCancelButton={true}
            />
        </MDBox >
    );
}

export default UserForm;